export const TEST_IDS = {
  auth: {
    page: "auth-page",
    emailInput: "auth-email-input",
    passwordInput: "auth-password-input",
    submit: "auth-submit-btn",
    error: "auth-error",
    demoAdmin: "auth-demo-admin",
    demoManager: "auth-demo-manager",
    demoDriver: "auth-demo-driver",
  },
  layout: {
    sidebarPrimary: "sidebar-primary",
    sidebarSecondary: "sidebar-secondary",
    headerLogo: "header-logo",
    userMenu: "header-user-menu",
    logout: "header-logout-btn",
    navDashboard: "nav-dashboard",
    navHistoryPro: "nav-history-pro",
    navHistoryPerso: "nav-history-perso",
    navReportsPro: "nav-reports-pro",
    navReportsPerso: "nav-reports-perso",
    navTaxSwiss: "nav-tax-swiss",
    navSettings: "nav-settings",
  },
  dashboard: {
    page: "dashboard-page",
    kpiProKm: "kpi-pro-km",
    kpiPersoKm: "kpi-perso-km",
    kpiTotalKm: "kpi-total-km",
    kpiUnclassifiedKm: "kpi-unclassified-km",
    kpiPctPro: "kpi-pct-pro",
    kpiPctPerso: "kpi-pct-perso",
    kpiFuel: "kpi-fuel",
    kpiFuelPerso: "kpi-fuel-perso",
    table: "dashboard-driver-table",
    pieChart: "dashboard-pie-chart",
    lineChart: "dashboard-line-chart",
    filterDriver: "dashboard-filter-driver",
    filterVehicle: "dashboard-filter-vehicle",
    filterGroup: "dashboard-filter-group",
    filterCompany: "dashboard-filter-company",
    filterStart: "dashboard-filter-start",
    filterEnd: "dashboard-filter-end",
  },
  history: {
    page: "history-page",
    table: "history-trips-table",
    classifyPro: "history-classify-pro",
    classifyPerso: "history-classify-perso",
    filterDriver: "history-filter-driver",
    filterVehicle: "history-filter-vehicle",
    filterGroup: "history-filter-group",
    filterCompany: "history-filter-company",
    filterStart: "history-filter-start",
    filterEnd: "history-filter-end",
  },
  reports: {
    page: "reports-page",
    btnPdf: "reports-btn-pdf",
    btnXlsx: "reports-btn-xlsx",
    btnCsv: "reports-btn-csv",
    btnTaxPdf: "reports-btn-tax-pdf",
    yearInput: "reports-year-input",
  },
  settings: {
    page: "settings-page",
    modeA: "settings-mode-a",
    modeB: "settings-mode-b",
    modeC: "settings-mode-c",
    timeStart: "settings-work-start",
    timeEnd: "settings-work-end",
    save: "settings-save-btn",
    vehicleModeSelect: "settings-vehicle-mode",
  },
};
